import { useState } from 'react';
import { CategoryRow } from './CategoryRow.jsx';
import { CategoryExpanded } from './CategoryExpanded.jsx';

/**
 * Single-open category accordion. Holds the id of the currently open
 * category — clicking an open row closes it, clicking a closed row swaps
 * which category is open. The check-level accordions inside each panel
 * track their own state independently.
 */
export function CategoryAccordion({ categories, reportId, dcmaPoints }) {
  const [openId, setOpenId] = useState(null);
  const visible = (categories || []).filter((c) => !c.hidden);

  if (visible.length === 0) {
    return <p className="table-empty">No categories to display.</p>;
  }

  return (
    <div className="cat-accordion" role="list">
      {visible.map((category, i) => {
        const isOpen = openId === category.id;
        return (
          <div key={category.id} className="cat-block" role="listitem">
            <CategoryRow
              category={category}
              even={i % 2 === 1}
              open={isOpen}
              onToggle={() => setOpenId(isOpen ? null : category.id)}
            />
            {isOpen && (
              <CategoryExpanded
                category={category}
                reportId={reportId}
                dcmaPoints={dcmaPoints}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
